/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import './AirTicketViewModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CardContentTile from '../../../components/CardContentTile/CardContentTile';
import { fonts, themes } from '../../../themes/themes';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import VerticalBarController from '../../../components/VerticalBar/VerticalBarController';
import { getAmount } from '../../../configs/utils';
import { useAppSelector } from '../../../../infra/hooks';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../helper';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  airticketViewData: any;
  trans?: any;
}

const AirTicketViewModalPresenter = ({
  isModalOpen,
  closeModal,
  airticketViewData,
  trans,
}: ModalProps) => {
  const handleSubmit = () => {
    closeModal();
  };

  const currency = useAppSelector((state) => state.authSlice.currency);
  return (
    <div>
      <CustomModal
        isModalOpen={isModalOpen}
        modalHeight="755px"
        modalWidth="auto"
      >
        <ModalHeader
          modal={{ modal_title: trans('Air Ticket Details') }}
          closeModal={closeModal}
        />
        <Grid
          container
          style={{
            marginTop: '35px',
          }}
        >
          <Grid item xs={7} className="left-grid_airTicketView">
            <Grid container style={{ padding: '10px' }}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Ticket Details')}
                </Typography>
              </Grid>

              <CardContentTile
                tile_key={trans('Trip Type')}
                tile_value={airticketViewData?.trip_type?.name}
              />
              <CardContentTile
                tile_key={trans('Type')}
                tile_value={
                  airticketViewData?.ticket_for
                    ? airticketViewData?.ticket_for
                    : '--'
                }
              />
              <CardContentTile
                tile_key={trans('Ticket Request')}
                tile_value={
                  airticketViewData?.request_for == 1
                    ? trans('Round Ticket')
                    : trans('One Way')
                }
              />
              <CardContentTile
                tile_key={trans('Destination')}
                tile_value={airticketViewData?.destination}
              />
              <CardContentTile
                tile_key={trans('Travel Date')}
                tile_value={
                  <DateField
                    value={airticketViewData?.date}
                    format={baseDateFormatting}
                  />
                }
              />
              <CardContentTile
                tile_key={trans('Return Date')}
                tile_value={
                  airticketViewData?.return_date ? (
                    <DateField
                      value={airticketViewData?.return_date}
                      format={baseDateFormatting}
                    />
                  ) : (
                    '--'
                  )
                }
              />
              <CardContentTile
                tile_key={trans('Amount')}
                tile_value={
                  airticketViewData?.amount
                    ? `${currency} ${getAmount(airticketViewData?.amount)}`
                    : '--'
                }
              />
              <CardContentTile
                tile_key={trans('Remarks')}
                tile_value={
                  airticketViewData?.description
                    ? airticketViewData?.description
                    : airticketViewData?.remarks
                      ? airticketViewData?.remarks
                      : '--'
                }
              />
            </Grid>
            {airticketViewData?.ticket_photo && (
              <Grid container style={{ padding: '10px' }}>
                <Grid item xs={12}>
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Attachments')}
                  </Typography>
                </Grid>
                <Box style={{ marginTop: '35px' }} />

                <DropAndSelect
                  src={airticketViewData?.ticket_photo}
                  disabledDeleteBtn={true}
                />
              </Grid>
            )}
          </Grid>
          <Grid item xs={1}>
            {' '}
          </Grid>
          <Grid item xs={4} className="right-grid_airTicketView">
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Tracking Details')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <VerticalBarController
                  instanceId={airticketViewData?.workflow_instance?.id}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box style={{ marginTop: '35px' }} />
        <ModalFooter
          onClickSubmit={() => handleSubmit()}
          onClickCancel={() => {
            closeModal();
          }}
          isSubmitButton={false}
        />
      </CustomModal>
    </div>
  );
};

export default AirTicketViewModalPresenter;
